module.exports = __webpack_public_path__ + "static/media/app_development.6760014a.svg";